import axios from 'axios'
import defaults from '@/utils/defaults'
import store from '@/store'
import router from '@/router'

console.log("[i] Launching app. Using this root api URL: " + defaults.VUE_APP_ROOT_API)




const backend_api = axios.create({
    xsrfCookieName: 'csrftoken',
    xsrfHeaderName: 'X-CSRFToken',
    baseURL: defaults.VUE_APP_ROOT_API,
    validateStatus: function (status) {
        return status >= 200 && status < 300; // default
    },
});
backend_api.interceptors.request.use(config => {
    if (store.state.session.authenticated) {
        config['headers']['Authorization'] = 'Bearer ' + store.state.session.access_token
    } else {
        config['headers']['Authorization'] = 'NO_AUTH'
    }
    return config
})
backend_api.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error?.response?.status == 403 && error.response?.data?.code == "token_not_valid") {
            store.dispatch("session/refresh")
        }
        else if (error?.response?.status == 403 && error?.response?.data?.detail == "You do not have permission to perform this action.") {
            console.log("[!] Permission error. Check the Network tab in the browser.")
            return Promise.reject(error)
        }
        else if (error?.response?.status == 403) {
            store.commit('session/cleanSession')
            router.push("/login").catch(() => console.log("[!] Can't go to login. Maybe already in login page."))
        }
        else if (error?.response?.status == 401 && error.response?.data?.code == "token_not_valid") {
            store.commit('session/cleanSession')
            router.push("/login").catch(() => console.log("[!] Can't go to login. Maybe already in login page."))
        }
        return Promise.reject(error)
    }
)


// returns a complete promise
function paginated_factory(url) {
    return function paginatedFetcher(next, obj_list = []) {
        return backend_api.get(next ? next : url)
            .then(({ data }) => {
                obj_list.push(...data.results)
                if (!data.next) return obj_list
                return paginatedFetcher(data.next, obj_list)
            })
    }
}





export {
    backend_api,
    paginated_factory
};

// LOGOUT FROM SESSION !!!!!!
// axios.get(defaults.VUE_APP_LOGOUT_URL)
//     .then(console.log("Cleaned session"))



// LOGOUT FROM SESSION !!!!!!
axios.get(defaults.VUE_APP_ROOT_API + 'auth/logout/')
    .then(console.log("Cleaned session"))